import React from 'react';
import useInteractiveDemoPopup from '../../hooks/useInteractiveDemoPopup';
import InteractiveDemoPopup from './InteractiveDemoPopup';

const AutoInteractiveDemo = () => {
  const { isOpen, closePopup } = useInteractiveDemoPopup();

  return (
    <InteractiveDemoPopup 
      isOpen={isOpen} 
      closeModal={closePopup}
      demoUrl="/explore-product/?utm_source=auto_popup"
    />
  );
};

export default AutoInteractiveDemo; 